import { render, staticRenderFns } from "./SwitchTitle.vue?vue&type=template&id=200d95ee&scoped=true"
import script from "./SwitchTitle.vue?vue&type=script&lang=js"
export * from "./SwitchTitle.vue?vue&type=script&lang=js"
import style0 from "./SwitchTitle.vue?vue&type=style&index=0&id=200d95ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d95ee",
  null
  
)

export default component.exports